// More comprehensive Markdown to HTML converter
export const markdownToHtml = (markdown) => {
  if (!markdown) return '';

  // Split the markdown into lines to process block elements
  const lines = markdown.split('\n');
  let html = '';
  let inParagraph = false;
  let inUnorderedList = false;
  let inOrderedList = false;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    
    // Handle headers
    if (line.startsWith('# ')) {
      if (inParagraph) {
        html += '</p>';
        inParagraph = false;
      }
      if (inUnorderedList) {
        html += '</ul>';
        inUnorderedList = false;
      }
      if (inOrderedList) {
        html += '</ol>';
        inOrderedList = false;
      }
      html += `<h1>${processInlineMarkdown(line.substring(2))}</h1>`;
      continue;
    }
    
    if (line.startsWith('## ')) {
      if (inParagraph) {
        html += '</p>';
        inParagraph = false;
      }
      if (inUnorderedList) {
        html += '</ul>';
        inUnorderedList = false;
      }
      if (inOrderedList) {
        html += '</ol>';
        inOrderedList = false;
      }
      html += `<h2>${processInlineMarkdown(line.substring(3))}</h2>`;
      continue;
    }
    
    if (line.startsWith('### ')) {
      if (inParagraph) {
        html += '</p>';
        inParagraph = false;
      }
      if (inUnorderedList) {
        html += '</ul>';
        inUnorderedList = false;
      }
      if (inOrderedList) {
        html += '</ol>';
        inOrderedList = false;
      }
      html += `<h3>${processInlineMarkdown(line.substring(4))}</h3>`;
      continue;
    }
    
    // Handle blockquotes
    if (line.startsWith('> ')) {
      if (inParagraph) {
        html += '</p>';
        inParagraph = false;
      }
      if (inUnorderedList) {
        html += '</ul>';
        inUnorderedList = false;
      }
      if (inOrderedList) {
        html += '</ol>';
        inOrderedList = false;
      }
      html += `<blockquote>${processInlineMarkdown(line.substring(2))}</blockquote>`;
      continue;
    }
    
    // Handle unordered lists
    if (line.startsWith('- ') || line.startsWith('* ')) {
      if (!inUnorderedList) {
        if (inParagraph) {
          html += '</p>';
          inParagraph = false;
        }
        if (inOrderedList) {
          html += '</ol>';
          inOrderedList = false;
        }
        html += '<ul>';
        inUnorderedList = true;
      }
      html += `<li>${processInlineMarkdown(line.substring(2).trim())}</li>`;
      continue;
    }
    
    // Handle ordered lists
    const orderedListMatch = line.match(/^(\d+)\. (.+)/);
    if (orderedListMatch) {
      if (!inOrderedList) {
        if (inParagraph) {
          html += '</p>';
          inParagraph = false;
        }
        if (inUnorderedList) {
          html += '</ul>';
          inUnorderedList = false;
        }
        html += '<ol>';
        inOrderedList = true;
      }
      html += `<li>${processInlineMarkdown(orderedListMatch[2].trim())}</li>`;
      continue;
    }
    
    // Handle empty lines (end of paragraph or list)
    if (line === '') {
      if (inParagraph) {
        html += '</p>';
        inParagraph = false;
      }
      if (inUnorderedList) {
        html += '</ul>';
        inUnorderedList = false;
      }
      if (inOrderedList) {
        html += '</ol>';
        inOrderedList = false;
      }
      continue;
    }
    
    // Handle regular paragraphs
    if (!inParagraph) {
      if (inUnorderedList) {
        html += '</ul>';
        inUnorderedList = false;
      }
      if (inOrderedList) {
        html += '</ol>';
        inOrderedList = false;
      }
      html += '<p>';
      inParagraph = true;
    } else {
      html += '<br>'; // Add line break within paragraph
    }
    
    html += processInlineMarkdown(line);
  }
  
  // Close any remaining open tags
  if (inParagraph) {
    html += '</p>';
  }
  if (inUnorderedList) {
    html += '</ul>';
  }
  if (inOrderedList) {
    html += '</ol>';
  }
  
  return html;
};

// Process inline markdown elements like bold, italic, links
function processInlineMarkdown(text) {
  if (!text) return '';
  
  // Handle bold (**text** or __text__)
  text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  text = text.replace(/__(.*?)__/g, '<strong>$1</strong>');
  
  // Handle italic (*text* or _text_)
  text = text.replace(/\*(.*?)\*/g, '<em>$1</em>');
  text = text.replace(/_(.*?)_/g, '<em>$1</em>');
  
  // Handle links [text](url)
  text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');
  
  // Handle images ![alt](url)
  text = text.replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1">');
  
  return text;
}